// extracted by mini-css-extract-plugin
export default {"send_page_email":"SendPage_send_page_email__JU1dr"};